"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfLineStickerLogSearchModel = instanceOfLineStickerLogSearchModel;
exports.LineStickerLogSearchModelFromJSON = LineStickerLogSearchModelFromJSON;
exports.LineStickerLogSearchModelFromJSONTyped = LineStickerLogSearchModelFromJSONTyped;
exports.LineStickerLogSearchModelToJSON = LineStickerLogSearchModelToJSON;
exports.LineStickerLogSearchModelToJSONTyped = LineStickerLogSearchModelToJSONTyped;
/**
 * Check if a given object implements the LineStickerLogSearchModel interface.
 */
function instanceOfLineStickerLogSearchModel(value) {
    return true;
}
function LineStickerLogSearchModelFromJSON(json) {
    return LineStickerLogSearchModelFromJSONTyped(json, false);
}
function LineStickerLogSearchModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'lineId': json['lineId'] == null ? undefined : json['lineId'],
        'memberName': json['memberName'] == null ? undefined : json['memberName'],
        'lineUserName': json['lineUserName'] == null ? undefined : json['lineUserName'],
        'action': json['action'] == null ? undefined : json['action'],
        'dateFrom': json['dateFrom'] == null ? undefined : json['dateFrom'],
        'dateTo': json['dateTo'] == null ? undefined : json['dateTo'],
    };
}
function LineStickerLogSearchModelToJSON(json) {
    return LineStickerLogSearchModelToJSONTyped(json, false);
}
function LineStickerLogSearchModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'lineId': value['lineId'],
        'memberName': value['memberName'],
        'lineUserName': value['lineUserName'],
        'action': value['action'],
        'dateFrom': value['dateFrom'],
        'dateTo': value['dateTo'],
    };
}
